import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateRateCardRequest extends BaseUpdateRequest {
    name: string;
    driverUnitExpenseChargeRate = 0;
}